import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';
import { Link } from 'react-router-dom';

export function BannerSlider({ imagesMobile, imagesDesktop, descriptionImages, titles, subtitles }) {
    return (
        <>
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                pagination={{
                    clickable: true
                }}
                navigation={true}
                autoplay={{
                    delay: 6000,
                    disableOnInteraction: false
                }}
                loop={imagesMobile.length>1}
                modules={[Pagination, Navigation, Autoplay]}
            >
                {
                    imagesMobile.map((item, index) => (
                        <SwiperSlide 
                            className='slider-banner w-100 position-relative'
                            key={index}
                        >
                            <picture className='slider-banner__picture'>
                                <source srcSet={imagesDesktop[index]} media='(min-width: 576px)' />
                                <img className='slider-banner__img w-100' src={item} srcSet={`${item} 2x, ${imagesDesktop[index]} 576w`} alt={descriptionImages} />
                            </picture>
                            <div className='slider-banner__overlay w-100 h-100 position-absolute'></div>
                            <div className='slider-banner__text w-100 h-100 d-flex flex-column justify-content-center align-items-center position-absolute'>
                                <h1 className='slider-banner__title text-center container'>{titles[index]}</h1>
                                <h2 className='slider-banner__subtitle text-center container'>{subtitles[index]}</h2>
                                <Link className='slider-banner__button mt-4' to="/contacto">Contáctanos</Link>
                            </div>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </>
    );
}